import "./chart.scss";
import {
  AreaChart,
  Area,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useFetch from "../../hooks/useFetch";
import { useEffect, useState } from "react";
import moment from 'moment'


const Chart = ({ aspect, title }) => {


  const bookingData = useFetch(`/rooms/booking/:id`);
  var count = 0;
  var earnings = bookingData.data.map((item, i) => {
    return (count += item.amount);
  });


// 
var monthsOf2022_services = { 'Jan': [], 'Feb': [], 'Mar': [], 'Apr': [], 'May': [], 'Jun': [], 'Jul': [], 'Aug': [], 'Sep': [], 'Oct': [], 'Nov': [], 'Dec': [] }
const bb = bookingData.data.map((data) => {
    if ('2022' == moment(data.createdAt).format('YYYY')) {

        if ('01' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Jan.push(data.createdAt)
        }
        else if ('02' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Feb.push(data.createdAt)
        }
        else if ('03' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Mar.push(data.createdAt)
        }
        else if ('04' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Apr.push(data.createdAt)
        }
        else if ('05' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.May.push(data.createdAt)
        }
        else if ('06' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Jun.push(data.createdAt)
        }
        else if ('07' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Jul.push(data.createdAt)
        }
        else if ('08' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Aug.push(data.createdAt)
        }
        else if ('09' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Sep.push(data.createdAt)
        }
        else if ('10' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Oct.push(data.createdAt)
        }
        else if ('11' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Nov.push(data.createdAt)
        }
        else if ('12' == moment(data.createdAt).format('MM')) {
            monthsOf2022_services.Dec.push(data.createdAt)
        }
    }

})
// console.log("monthsOf2022_services",monthsOf2022_services)
  // 
  const data = [
    { name: "July", Total:  monthsOf2022_services?.Jul.length },
    { name: "August", Total: monthsOf2022_services?.Aug.length  },
    { name: "September", Total: monthsOf2022_services?.Sep.length  },
    { name: "October", Total: monthsOf2022_services?.Oct.length  },
    { name: "November", Total: monthsOf2022_services?.Nov.length  },
    { name: "December", Total: monthsOf2022_services?.Dec.length  },
  ];
  
  return (
    <div className="chart">
      <div className="title">{title}</div>
      <ResponsiveContainer width="100%" aspect={aspect}>
        <AreaChart
          width={730}
          height={250}
          data={data}
          margin={{ top: 10, right: 30, left: 30, bottom: 0 }}
        >

        
          <defs>
            <linearGradient id="total" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#218ef3" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#218ef3" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" stroke="gray" />
          <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="Total"
            stroke="#218ef3"
            fillOpacity={1}
            fill="url(#total)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart;
